import { Link } from 'react-router-dom'
import { ChevronRight, User, Phone, Mail, AtSign, FileText } from 'lucide-react'
import { useApiAuth } from '@/modules/auth-api'

export function AccountPage() {
  const user = useApiAuth((s) => s.user)
  if (!user) {
    return (
      <div className="max-w-[720px] mx-auto px-6 py-16 text-center">
        <h1 className="text-2xl font-bold text-text">Vui lòng đăng nhập</h1>
        <Link to="/dang-nhap" className="mt-5 inline-flex h-11 px-6 rounded-md bg-brand-600 hover:bg-brand-700 text-white font-semibold text-sm items-center">
          Đăng nhập
        </Link>
      </div>
    )
  }
  return (
    <div className="max-w-[920px] mx-auto px-6 py-6">
      <nav className="flex items-center gap-1.5 text-sm text-muted mb-4">
        <Link to="/" className="hover:text-brand-600">Trang chủ</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-text font-medium">Tài khoản của tôi</span>
      </nav>
      <h1 className="text-2xl font-bold text-text mb-5">Tài khoản của tôi</h1>
      <div className="bg-surface border border-border rounded-xl shadow-card p-6 space-y-3">
        <Row icon={User} label="Họ tên" value={user.fullName} />
        <Row icon={AtSign} label="Username" value={user.username} />
        <Row icon={Mail} label="Email" value={user.email} />
        <Row icon={Phone} label="SĐT" value={user.phone || '—'} />
      </div>
      <div className="mt-4">
        <Link to="/don-hang" className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-brand-600 hover:bg-brand-700 text-white font-semibold text-sm">
          <FileText className="w-4 h-4" /> Xem đơn hàng của tôi
        </Link>
      </div>
    </div>
  )
}

function Row({ icon: Icon, label, value }: { icon: React.ComponentType<{ className?: string }>; label: string; value: string }) {
  return (
    <div className="flex items-center gap-3 py-2 border-b border-border last:border-b-0">
      <Icon className="w-4 h-4 text-muted" />
      <div className="w-28 text-sm text-muted">{label}</div>
      <div className="text-sm text-text font-medium">{value}</div>
    </div>
  )
}
